export const getAPIURL = () => {
    let url = 'https://' + window.location.hostname + '/webapi/'

    if (window.location.hostname.toUpperCase().includes('LOCALHOST') || window.location.hostname.toUpperCase().includes('LOCALNET')) {
        if (process.env.REACT_APP_CUSTOM_ENV) {
            url = `https://${process.env.REACT_APP_CUSTOM_ENV}.awc-inc.com/webapi/`
        } else if (
            process.env.NODE_ENV === 'development' ||
            process.env.REACT_APP_CUSTOM_ENV === 'nettest'
        ) {
            url = 'https://nettest.awc-inc.com/webapi/'
        } else if (
            process.env.NODE_ENV === 'production' ||
            process.env.REACT_APP_CUSTOM_ENV === 'prod'
        ) {
            url = 'https://net.awc-inc.com/webapi/'
        } else {
            url = 'https://nettest.awc-inc.com/webapi/'
        }
    }

    return url
}

export const getAPICSURL = () => {
    let url = 'https://' + window.location.hostname + '/webapics/api/v1/'

    if (window.location.hostname.toUpperCase().includes('LOCALHOST')) {
        if (process.env.REACT_APP_CUSTOM_ENV) {
            url = `https://${process.env.REACT_APP_CUSTOM_ENV}.awc-inc.com/webapics/api/v1/`
        } else if (
            process.env.NODE_ENV === 'development' ||
            process.env.REACT_APP_CUSTOM_ENV === 'nettest'
        ) {
            url = 'https://nettest.awc-inc.com/webapics/api/v1/'
        }
    }

    return url
}

export const getBaseURL = () => {
    let url = `https://${window.location.hostname}/`

    if (window.location.hostname.toUpperCase().includes('LOCALHOST')) {
        if (process.env.REACT_APP_CUSTOM_ENV) {
            url = `https://${process.env.REACT_APP_CUSTOM_ENV}.awc-inc.com/`
        } else if (
            process.env.NODE_ENV === 'development' ||
            process.env.REACT_APP_CUSTOM_ENV === 'dev'
        ) {
            url = 'https://nettest.awc-inc.com/'
        } else if (
            process.env.NODE_ENV === 'production' ||
            process.env.REACT_APP_CUSTOM_ENV === 'prod'
        ) {
            url = 'https://net.awc-inc.com/'
        } else {
            url = 'https://nettest.awc-inc.com/'
        }
    }

    return url
}

